import apiClient from "./apiClient";

const get  = (url, params = {})       => apiClient.get(url, { params }).then((r) => r.data);
const post = (url, body) => apiClient.post(url, body).then((r) => r.data);
const put = (url) => apiClient.put(url).then((r) => r.data);

export const fetchWalletTransactions = (params = {}) =>
    get("/wallet-transactions", params);

export const fetchfinanceAccounts = (params = {}) =>
    get("/finance/accounts", params);



export const fetchCustomers = (params = {}) => get("/customers", params);
export const fetchCustomerDetails = (id) => get(`/customers/${id}`);
export const saveCustomerDetails = (id, data) => post(`/customers/${id}/save`, data);

export const fetchCustomerMessagingTemplates = () =>
    post("/setting/whatsapp-templates");

export const previewCustomerMessagingTargets = (data) =>
    post("/customer-messaging/preview-targets", data);

export const sendCustomerPushNotification = (data) =>
    post("/customer-messaging/send-push", data);

export const sendCustomerWhatsappMessage = (data) =>
    post("/customer-messaging/send-whatsapp", data);

export const fetchStorePayoutRequests = (params = {}, signal = null) =>
    get("/store-payouts", params, signal ? { signal } : {});

export const sendStorePayoutRequest = (data) =>
    post("/store-payouts/request", data);

export const sendAllStorePayoutRequests = () =>
    post("/store-payouts/request-all", {});








export const fetchAllSurges = () =>
    get('/surges');

export const createSurge = async (data) =>
    post('/surges/create', data);

export const activateSurge = async (id) =>
    post('/surges/activate', {id});

export const updateSurge = async (data) =>
    post('/surges/update', data);

export const deactivateAllSurges = async () =>
    put('/surges/deactivate-all');


export const fetchStorePayouts = (params = {}) =>
    get("/store-payouts/history", params);

export const fetchStorePayoutDetails = (id) =>
    get(`/store-payouts/${id}`);

export const updateStorePayoutStatus = (id, data) =>
    apiClient.patch(`/store-payouts/${id}`, data).then((r) => r.data);


export const fetchSurgeStats = (id, params) =>
    post(`/surges/${id}/stats`, params);


export const fetchCashCollections = (params = {}) =>
    get("/finance/cash-collections", params);

export const collectCashCollection = (data) =>
    post("/finance/cash-collections/collect", data);

export const fetchCashCollectionLogs = (params = {}) =>
    get("/finance/cash-collections/logs", params);


const normalizeLocalhostUrl = (url) => {
    if (!url) return url;
    return String(url)
        .replace("https://localhost:8000", "http://localhost:8000")
        .replace("https://127.0.0.1:8000", "http://127.0.0.1:8000");
};

export const fetchStoreEditData = (id) =>
    get(`/stores/${id}/edit-data`).then((data) => {
        if (data?.data?.store) {
            data.data.store.image_url = normalizeLocalhostUrl(data.data.store.image_url);
            data.data.store.image = normalizeLocalhostUrl(data.data.store.image);
        }

        if (data?.data?.store_public_url) {
            data.data.store_public_url = normalizeLocalhostUrl(data.data.store_public_url);
        }

        return data;
    });


export const fetchStoreItem = (id, itemId) =>
    get(`/stores/${id}/items/${itemId}`);

export const updateStore = (id, data) =>
    apiClient.post(`/stores/${id}/update`, data, {
        headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);



export const createStoreItem = async (id, formData) => {
    const res = await apiClient.post(`/stores/${id}/items`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
};


export const fetchStoreItems = (id, params = {}) =>
    get(`/stores/${id}/items`, { params });


export const fetchStoreItemMeta = (id) =>
    get(`/stores/${id}/items/meta`);


export const toggleStoreItemActive = async (id, itemId, is_active) => {
    return (await apiClient.patch(`/stores/${id}/items/${itemId}/active`, {
        is_active,
    }))?.data;
};

export const removeStoreItemImage = async (id, itemId) => {
    const res = await apiClient.delete(`/stores/${id}/items/${itemId}/image`);
    return res.data;
};

export const updateStoreItem = async (id, itemId, formData) => {
    const res = await apiClient.post(`/stores/${id}/items/${itemId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
};


export const fetchStoreSortData = (id) =>
    get(`/stores/${id}/sort-data`);

export const saveStoreItemSort = (id, newOrder) =>
    post(`/stores/${id}/items/sort`, { newOrder });

export const saveStoreCategorySort = (id, newOrder) =>
    post(`/stores/${id}/categories/sort`, { newOrder });

export const fetchAnalyticsDashboard = (params = {}) =>
    get("/analytics-dashboard", params);

export const exportAnalyticsDashboard = (params = {}) =>
    get("/analytics-dashboard/export", params);

export const previewCompetitorPricing = (id, data) =>
    post(`/stores/${id}/competitor-pricing/preview`, data);

export const applyCompetitorPricing = (id, data) =>
    post(`/stores/${id}/competitor-pricing/apply`, data);
